export enum AuthorityEnum {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  REGULAR = 'REGULAR'
}
